export function BookingNotFoundPage() {
  return (
    <div className='flex justify-center items-center min-h-dvh p-8'>
      <div className='flex flex-col gap-y-6 max-w-md text-center'>
        <h1 className='text-heading-2 text-fg-primary'>Page not found</h1>
        <p className='text-body text-fg-secondary'>
          This booking link doesn&apos;t exist or may have expired. Please check
          the link from the person who invited you, or contact them for an
          updated link.
        </p>
      </div>
    </div>
  );
}

export default BookingNotFoundPage;
